import { useEffect, useState } from 'react'

// Whether the scroll container overflows vertically — uses ResizeObserver on the first child so e.g. image loading retriggers the check
export const useIsOverflow = (ref) => {
    const [isOverflow, setIsOverflow] = useState(false)

    useEffect(() => {
        const elem = ref.current
        if (!elem) return

        const check = () => setIsOverflow(elem.scrollHeight > elem.clientHeight)
        check()

        // observe content wrapper — when images load or items added, it resizes, triggering re-check of whether scroll container overflows
        const observer = new ResizeObserver(check)
        if (elem.firstElementChild) observer.observe(elem.firstElementChild)

        return () => observer.disconnect()
    }, [ref])

    return isOverflow
}
